import api from './http';
import { LoginResponse } from '../types/api';

export interface LoginPayload {
  email: string;
  password: string;
}

export const loginRequest = async (payload: LoginPayload) => {
  const { data } = await api.post<LoginResponse>('/login', payload);
  return data;
};

export const logoutRequest = async () => {
  await api.post('/logout');
};

